import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
/*
This component is used in
components/pages/live/floorplan.jsx
components/pages/live/index.jsx
components/pages/sensorsettings/index.jsx
components/pages/user/index.js
*/
const optionClicked = (props, node) => {
	props.click(node);
}
const ListDropdown = (props) => {

	var header = props.getText(props.selected);
	var items = props.items.slice();
	// By default, filter out CONFIGURATION view
	if (props.isConfigurationView === undefined) {
		items = items.filter((item) => {
			return item.code !== "CONFIGURATION"
		})
	}
	return (
		<div className={props.outsideClass}>
			<Dropdown
				toggleable={true}
				header={header}
				className={props.className}
			>
				{
					items.map(
						(x, idx) => (
							<DropdownItem key={idx}>
								<div onClick={optionClicked.bind(this, props, x)}>
									{props.getText(x)}
								</div>
							</DropdownItem>
						)
					)
				}
			</Dropdown>
		</div>
	)
}
export default ListDropdown


// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/listdropdown/index.jsx